
import { User } from '@/classes/auth';
import { SubscriptionState } from '@/classes/stripe';

import EmptyState from '@/components/EmptyState.vue';
import ActiveSubscription from '@/components/Subscription/ActiveSubscription.vue';
import EventService from '@/Services/EventService';
import StripeSubscriptionService from '@/Services/Subscription/StripeSubscriptionService';
import store from '@/store';
import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  components: {
    EmptyState,
    ActiveSubscription,
  },
  computed: {
    ...mapState<SubscriptionState>('subscription', {
      showLoadingSubscription: (state: SubscriptionState) => state.showLoading,
    }),
  },
})
export default class BillingDetail extends Vue {
  // state from vuex
  activeSubscription = store.state.subscription.activeSubscription;

  user: User = store.state.auth.user;
  errorSubscription = false;
  invoices = store.state.account.invoices || [];
  hasInvoices = this.invoices?.length || false;
  tryAgainSubscription = false;
  showLoadingSubscription!: any;

  // Handles payment method logic and some of the form state
  stripeSubscriptionService: StripeSubscriptionService = new StripeSubscriptionService();

  // METHODS

  async loadSubscriptionPlan(tryAgain?: boolean): Promise<void> {
    if (tryAgain) {
      this.errorSubscription = false;
      this.tryAgainSubscription = true;
    }

    // Reload Subscription
    if (this.activeSubscription.id == 0 || tryAgain) {
      await this.$store.dispatch('subscription/loadSubscription');
      this.errorSubscription = false;
      this.tryAgainSubscription = false;
    }

    // Validate reloaded subscription
    if (this.activeSubscription.id == 0) {
      this.errorSubscription = true;
      this.tryAgainSubscription = false;
    }

    if (this.invoices) {
      this.errorSubscription = false;
      this.hasInvoices = true;
    }
  }

  // METHODS END

  async created(): Promise<void> {
    await this.stripeSubscriptionService.initSubscription();
    await this.loadSubscriptionPlan();
    EventService.createEvent(EventService.VISITED_PAGE_BILLING);
  }
}
